import BaseOutlineText from "../../../components/general/BaseOutlineText";
import BaseText from "../../../components/general/BaseText";

type PainPointCardType = {
  text: string;
  number: string;
};

export default function PainPointCard(props: PainPointCardType) {
  return (
    <div className="painPointElement w-[calc(100%-1rem)] sm:w-[32rem] h-64 bg-base-200 flex p-4 rounded-default">
      <div className="flex h-full w-1/4 justify-center items-center pr-2">
        <BaseOutlineText
          blockTextAnimation
          weight={"medium"}
          text={props.number}
          textSize="text-5xl sm:text-7xl"
        />
      </div>
      <div className="flex h-full w-full sm:w-3/4 border border-secondary rounded-md items-center">
        <BaseText
          textColor="text-white/80"
          blockTextAnimation
          padding="p-4 text-center"
          text={props.text}
        />
      </div>
    </div>
  );
}
